import React, { useEffect, useState } from 'react';
import HomeLayout from '../../containers/HomeLayout';

import heartbeat from '../../assets/img/home/heartbeat.svg';
import ethnicity from '../../assets/img/home/Ethnicity.svg';
import religion from '../../assets/img/home/Religion.svg';
import smoking from '../../assets/img/home/Smoking.svg';
import drinking from '../../assets/img/home/Drinking.svg';
import height from '../../assets/img/home/Height.svg';

import { Snackbar, IconButton} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import * as profileActions from '../../store/actions/profileActions';
import * as messageActions from '../../store/actions/messageActions';
import { useDispatch, useSelector } from 'react-redux';

import '../../assets/css/home.css';
import '../../assets/css/chat.css';

const HomeScreen = () => {
    const [open, setOpen] = useState(false);
    const profileState = useSelector(state => state.profile);
    const dispatch = useDispatch();
  
    const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
  
      setOpen(false);
    };

    const getAge = (userDob) => {
        var dob = new Date(userDob);
        var age = (new Date().getFullYear()) - dob.getFullYear();

        return age;
    }

    const handleHeart = (firstMoveProfileId, secondMoveProfileId, profile) => {
        dispatch(messageActions.addInterestedInYou(firstMoveProfileId, secondMoveProfileId, profile))
            .then(() => {
                setOpen(true);
            })
    }

    const renderMatchBlocks = () => {
        var profileMatchBlocks = profileState.profiles.map((profile, i) => {
            if (profileState.preferenceFilters !== null) {
                if (getAge(profile.dateOfBirth) <= profileState.preferenceFilters.age && 
                    profile.universityInfo.campus === profileState.preferenceFilters.campus) {
                        return (
                            <div className="match-block" key={i}>
                                    
                                <div className="heart">
                                    <button onClick={() => handleHeart(profileState.userProfile.profileId, profile.profileId, profile)} style={{background: 'none', border: 'none'}}>
                                        <img src={heartbeat} height={40} width={40} alt="height" />
                                    </button>
                                </div>
            
                                <div className="match-details">
                                    <p className="match-name">{profile.profileName}, {getAge(profile.dateOfBirth)}</p>
                                    <p className="match-school">{profile.universityInfo.campus}, {profile.universityInfo.faculty}</p>
                                </div>
            
                                <div className="match-props">
                                    <span>
                                        <img style={{marginRight:'10px'}} src={ethnicity} alt="height" />
                                        <p>{profile.virtue.ethnicity}</p>
                                    </span>
                                    <span>
                                        <img style={{marginRight:'10px'}} src={religion} alt="height" />
                                        <p>{profile.virtue.religion}</p>
                                    </span>
                                    <span>
                                        <img style={{marginRight:'10px'}} src={smoking} alt="height" />
                                        <p>{profile.virtue.smoking}</p>
                                    </span>
                                    <span>
                                        <img style={{marginRight:'10px'}} src={drinking} alt="height" />
                                        <p>{profile.virtue.drinking}</p>
                                    </span>
                                    <span>
                                        <img style={{marginRight:'10px'}} src={height} alt="height" />
                                        <p>{profile.virtue.height}</p>
                                    </span>
                                </div>
                            </div>
                        );
                }
                else if (getAge(profile.dateOfBirth) <= profileState.preferenceFilters.age && 
                    profileState.preferenceFilters.campus === 'Everyone') {
                        return (
                            <div className="match-block" key={i}>
                                    
                                <div className="heart">
                                    <button onClick={() => handleHeart(profileState.userProfile.profileId, profile.profileId, profile)} style={{background: 'none', border: 'none'}}>
                                        <img src={heartbeat} height={40} width={40} alt="height" />
                                    </button>
                                </div>
            
                                <div className="match-details">
                                    <p className="match-name">{profile.profileName}, {getAge(profile.dateOfBirth)}</p>
                                    <p className="match-school">{profile.universityInfo.campus}, {profile.universityInfo.faculty}</p>
                                </div>
            
                                <div className="match-props">
                                    <span>
                                        <img style={{marginRight:'10px'}} src={ethnicity} alt="height" />
                                        <p>{profile.virtue.ethnicity}</p>
                                    </span>
                                    <span>
                                        <img style={{marginRight:'10px'}} src={religion} alt="height" />
                                        <p>{profile.virtue.religion}</p>
                                    </span>
                                    <span>
                                        <img style={{marginRight:'10px'}} src={smoking} alt="height" />
                                        <p>{profile.virtue.smoking}</p>
                                    </span>
                                    <span>
                                        <img style={{marginRight:'10px'}} src={drinking} alt="height" />
                                        <p>{profile.virtue.drinking}</p>
                                    </span>
                                    <span>
                                        <img style={{marginRight:'10px'}} src={height} alt="height" />
                                        <p>{profile.virtue.height}</p>
                                    </span>
                                </div>
                            </div>
                        );
                }
            }
            else{
                return (
                    <div className="match-block" key={i}>
                            
                        <div className="heart">
                            <button onClick={() => handleHeart(profileState.userProfile.profileId, profile.profileId, profile)} style={{background: 'none', border: 'none'}}>
                                <img src={heartbeat} height={40} width={40} alt="height" />
                            </button>
                        </div>
    
                        <div className="match-details">
                            <p className="match-name">{profile.profileName}, {getAge(profile.dateOfBirth)}</p>
                            <p className="match-school">{profile.universityInfo.campus}, {profile.universityInfo.faculty}</p>
                        </div>
    
                        <div className="match-props">
                            <span>
                                <img style={{marginRight:'10px'}} src={ethnicity} alt="height" />
                                <p>{profile.virtue.ethnicity}</p>
                            </span>
                            <span>
                                <img style={{marginRight:'10px'}} src={religion} alt="height" />
                                <p>{profile.virtue.religion}</p>
                            </span>
                            <span>
                                <img style={{marginRight:'10px'}} src={smoking} alt="height" />
                                <p>{profile.virtue.smoking}</p>
                            </span>
                            <span>
                                <img style={{marginRight:'10px'}} src={drinking} alt="height" />
                                <p>{profile.virtue.drinking}</p>
                            </span>
                            <span>
                                <img style={{marginRight:'10px'}} src={height} alt="height" />
                                <p>{profile.virtue.height}</p>
                            </span>
                        </div>
                    </div>
                );
            }
            
        });

        return profileMatchBlocks;
    }

    useEffect(() => {
        dispatch(profileActions.fetchProfiles(profileState.userProfile.profileId));
    }, [profileState.userProfile]);

    return (
        <HomeLayout>
            <Snackbar
                anchorOrigin={{vertical: 'top',horizontal: 'right'}}
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}
                message="Made your move"
                action={
                    <React.Fragment>
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </React.Fragment>
                } />
            <div className="pref-button-row">
                <a href="#">
                    <i className="fa fa-sliders" style={{color:'#41004C'}}></i>
                </a>
            </div>

            <div className="content-row">
                <div className="content-title">
                    <h1>Recommended Matches</h1>
                    <h4>Renewed Everyday at 5am</h4>
                </div>

                <div className="content-blocks">
                    {renderMatchBlocks()}
                </div>
            </div>
        </HomeLayout>
    );
};

export default HomeScreen;